module.exports = __webpack_public_path__ + "img/responsive hospitium-13.813e8b07.jpg";